import React from 'react'
import PropTypes from 'prop-types'
import { withResponsive } from './utils/withResponsive'
import { GridContainer } from './Container'
import { Row } from './Row'
import { Column } from './Column'

const styles = {
  absoluteContainer: {
    height: '100vh',
    left: 0,
    pointerEvents: 'none',
    position: 'absolute',
    top: 0,
    width: '100%',
    zIndex: 9000
  },
  relativeContainer: {
    position: 'relative'
  },
  breakpointContainer: {
    left: 10,
    position: 'absolute',
    top: 10,
    zIndex: 9001
  },
  breakpointPill: {
    borderRadius: '5px',
    fontSize: '20px',
    justifyContent: 'center',
    minHeight: '30px',
    minWidth: '0px',
    padding: '5px 10px'
  },
  breakpointColor: {
    mobile: {
      backgroundColor: '#ffb3c7'
    },
    tablet: {
      backgroundColor: '#daeebc'
    },
    desktop: {
      backgroundColor: '#bacaff'
    }
  },
  column: {
    backgroundColor: 'rgba(241, 222, 207, 0.4)',
    color: 'rgba(241, 222, 207, 0)',
    height: '100vh'
  }
}

const GridOverlayHelperContainer = ({ breakpoint, children, debug = false }) => {
  return debug ? (
    <>
      <div style={styles.absoluteContainer}>
        <div style={styles.relativeContainer}>
          <div style={styles.breakpointContainer}>
            <span
              style={{
                ...styles.breakpointPill,
                ...styles.breakpointColor[breakpoint]
              }}
            >
              {breakpoint}
            </span>
          </div>
          <GridContainer>
            <Row>
              <Column columns={{ mobile: 1 }}>
                <div style={styles.column}>Column</div>
              </Column>
              <Column columns={{ mobile: 1 }}>
                <div style={styles.column}>Column</div>
              </Column>
              <Column columns={{ mobile: 1 }}>
                <div style={styles.column}>Column</div>
              </Column>
              <Column columns={{ mobile: 1 }}>
                <div style={styles.column}>Column</div>
              </Column>
              <Column columns={{ mobile: 1 }}>
                <div style={styles.column}>Column</div>
              </Column>
              <Column columns={{ mobile: 1 }}>
                <div style={styles.column}>Column</div>
              </Column>
              <Column columns={{ mobile: 1 }}>
                <div style={styles.column}>Column</div>
              </Column>
              <Column columns={{ mobile: 1 }}>
                <div style={styles.column}>Column</div>
              </Column>
              <Column columns={{ mobile: 1 }}>
                <div style={styles.column}>Column</div>
              </Column>
              <Column columns={{ mobile: 1 }}>
                <div style={styles.column}>Column</div>
              </Column>
              <Column columns={{ mobile: 1 }}>
                <div style={styles.column}>Column</div>
              </Column>
              <Column columns={{ mobile: 1 }}>
                <div style={styles.column}>Column</div>
              </Column>
            </Row>
          </GridContainer>
        </div>
      </div>
      <>{children}</>
    </>
  ) : (
    <>{children}</>
  )
}

GridOverlayHelperContainer.propTypes = {
  breakpoint: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  debug: PropTypes.bool
}

export const GridOverlayHelper = withResponsive(GridOverlayHelperContainer)
